<section class="hero is-light is-fullheight" *ngIf="!login">
    <div class="hero-body">
        <div class="container has-text-centered">
            <div class="column is-4 is-offset-4">
                <h3 class="title has-text-black">Login</h3>
                <hr style="background-color: black;">
                <p class="subtitle has-text-black">Please login to proceed.</p>
                <div class="box">
                    <figure class="avatar">
                        <img src="../../assets/images/bonVoice .png">
                    </figure>
                    <form>
                        <div class="field">
                            <div class="control">
                                <input class="input is-large" type="email" placeholder="Your Email"  [(ngModel)]="username" name="username" autofocus="">
                            </div>
                        </div>

                        <div class="field">
                            <div class="control">
                                <input class="input is-large" type="password" placeholder="Your Password" [(ngModel)]="password" name="password">
                            </div>
                        </div>
                        <div class="field">
                            <label class="checkbox">
                                <input type="checkbox">
                                Remember me
                            </label>
                        </div>
                        <button (click)="onLogin()" class="button is-block is-info is-large is-fullwidth">Login <i class="fa fa-sign-in"
                                aria-hidden="true"></i></button>
                    </form>
                </div>
                <p class="has-text-grey">
                    <a href="../">Sign Up</a> &nbsp;·&nbsp;
                    <a href="../">Forgot Password</a> &nbsp;·&nbsp;
                    <a href="../">Need Help?</a>
                </p>
            </div>
        </div>
    </div>
</section>
